import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from "./InnerHeader";
import { type } from "@testing-library/user-event/dist/type";
import { StyledDataGrid } from "./StyledDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const FacultyMonthlyStatement = () => {
    const [hide, setHide] = useState([])
    const [salarydata, setsalarydata] = useState([])
    const [faculty, setFaculty] = useState([])
    const [value, setValue] = useState({
        period: "",
        periodyear: ""
    });
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [newserror, setNewserror] = useState({
        period: "",
        periodyear: ""
    });





    const handleSubmit = async (e) => {
        e.preventDefault();

        let errors = {};
        let hasError = false;

        if (!value.period || value.period === "--Select Months--") {
            errors.period = "Please select a period.";
            hasError = true;
        } else {
            errors.period = "";
        }

        if (!value.periodyear || value.periodyear === "--Select Year--") {
            errors.periodyear = "Please select a year.";
            hasError = true;
        } else {
            errors.periodyear = "";
        }

        setNewserror(errors);

        if (hasError) {
            return;
        }

        const body = {
            period: value.period,
            periodyear: value.periodyear,
        };

        try {
            const response = await axios.post(`${BASE_URL}/getsalaryreport`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            setsalarydata(response.data);
            setHide(true);

            setValue({
                period: "",
                periodyear: "",
            });

        } catch (error) {
            console.error("Error fetching faculty salary report:", error);
        }
    };


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const title = [["Faculty Monthly Statement Report "]];
        const headers = [
            ["Date", "Name", "PAN", "Charges P.H.", "Total Hours", "Amount", "T.D.S. %", "T.D.S. Amt", "Net Amt. Payble", "Cheque No", "Cheque Date", "Mode"]
        ];

        const body = salarydata.map(row => [
            row.Date_Added,
            row.Faculty_Name,
            row.PAN,
            row.Rate,
            row.Total_Hours,
            row.Tot_Inc,
            row.TDS_Per,
            row.TDS,
            row.Net_Payment,
            row.Cheque_No || "N/A",
            row.Cheque_Date || "",
            row.Payment_Type || "Select Type"
        ]);

        // Calculate totals for the footer
        const totalAmount = salarydata.reduce((sum, r) => sum + parseFloat(r.Tot_Inc || 0), 0);
        const totalTDS = salarydata.reduce((sum, r) => sum + parseFloat(r.TDS || 0), 0);
        const totalNetPay = salarydata.reduce((sum, r) => sum + parseFloat(r.Net_Payment || 0), 0);

        const footer = [
            ["", "", "", "", "", totalAmount, "", totalTDS, totalNetPay, "", "", ""]
        ];

        // Combine all
        const fullData = [...title, [], ...headers, ...body, ...footer];

        const ws = XLSX.utils.aoa_to_sheet(fullData);

        // Merge cells for the title (A1 to L1)
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }];

        // Set column widths
        ws["!cols"] = new Array(12).fill({ wch: 18 });

        XLSX.utils.book_append_sheet(wb, ws, "MonthlySalaryReport");

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "Faculty_Monthly_Report_2025.xlsx");
    };

    const roledata = {
        role: Cookies.get(`role`),
        pageid: 67,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);

    const columns = [
       {
    field: "Date_Added",
    headerName: "Date",
    align: "center",
    headerAlign: "center",
    flex: 1,
    filterable: false,
    renderCell: (params) => {
        if (!params.value) return "";

        // If in yyyymmdd format
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // If in yyyy-mm-dd or Date object
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    },
},

        {
            field: 'Faculty_Name',
            headerName: 'Name',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'PAN',
            headerName: 'PAN',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Rate',
            headerName: 'CHARGES P.H ',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Total_Hours',
            headerName: 'TOTAL HOURS',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Tot_Inc',
            headerName: 'AMOUNT',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'TDS_Per',
            headerName: 'T. D. S.%',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'TDS',
            headerName: 'T. D. S Amount',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Net_Payment',
            headerName: 'Net Amount Payable',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Cheque_No',
            headerName: 'Cheque No',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: '',
            headerName: 'Cheque Date',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Payment_Type',
            headerName: 'Mode',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },


    ];

    const rowsWithIds = salarydata.map((row, index) => ({ index: index + 1, ...row }));

    return (

        <div class="container-fluid page-body-warpper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">
                                        Faculty Monthly Salary Statement
                                    </h4>
                                    <hr></hr>

                                    <form class="form-sample py-3" onSubmit={handleSubmit} >
                                        <div class="row">
                                            <div class="form-group col-lg-3">
                                                <lable for="exampleFormControlSelect1">Period</lable>
                                                <select class="form-control" id="exampleFormControlSelecet1"
                                                    value={value.period} name="period"
                                                    onChange={onhandleChange}>
                                                    <option>--Select Months--</option>
                                                    <option value="January">January</option>
                                                    <option value="February">February</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                {newserror.period && <span style={{ color: 'red', fontSize: '12px' }}>{newserror.period}</span>}
                                            </div>

                                            <div class="form-group col-lg-2">
                                                <lable for="exampleFormControlSelect1">Year</lable>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.periodyear} name="periodyear"
                                                    onChange={onhandleChange}>
                                                    <option>--Select Year--</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2011">2011</option>
                                                </select>
                                                {newserror.periodyear && <span style={{ color: 'red', fontSize: '12px' }}>{newserror.periodyear}</span>}
                                            </div>

                                            <div class="d-flex align-items-center mt-3">
                                                <button type="submit" class="btn btn-sm btn-primary mr-2 py-2">Go</button>
                                            </div>


                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div className="d-flex justify-content-wrrper">
                                        <div>
                                            <h4 class="card-title">
                                                Details
                                            </h4>
                                        </div>
                                    </div>

                                    {hide && <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "scroll" }}>
                                        <StyledDataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            // disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            getRowId={(row) => row.Salary_Id}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500, // Ensure enough height for pagination controls
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            slots={{
                                                toolbar: GridToolbar
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />
                                    </div>}

                                    <button type="submit" class="btn btn-primary mr-2" onClick={exportToExcel}>Excel</button>
                                    <button type='button' onClick={() => {
                                        window.location.reload()
                                    }} class="btn btn-light">Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FacultyMonthlyStatement